module.exports = __webpack_public_path__ + "img/news_page.3ce110dc.png";